import React from 'react';

import { SVGComponentProps } from './svg.types';

const GettingStartedTwoSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <rect width="72" height="72" fill="#F9FAFB" />
          <rect
            x="35.1212"
            y="3.76519"
            width="34.3077"
            height="34.3077"
            transform="rotate(15.8262 35.1212 3.76519)"
            fill="#FF766C"
            stroke="#F9FAFB"
            strokeWidth="2"
          />
          <path
            d="M51.4045 35.5L50.5385 34L49.6725 35.5L31.0196 67.8077L30.1536 69.3077H31.8856H69.1914H70.9234L70.0574 67.8077L51.4045 35.5Z"
            fill="#7358E9"
            stroke="#F9FAFB"
            strokeWidth="2"
          />
          <circle cx="18" cy="41" r="17" fill="#FD9740" stroke="#F9FAFB" strokeWidth="2" />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="72" height="72" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </span>
  );
};

export default GettingStartedTwoSVG;
